import React from "react";
import "./styles.css";

function AnalyticsCard({ title, subtitle }) {
  return (
    <div className="analytics-card">
      <h2>{title}</h2>
      <p>{subtitle}</p>
    </div>
  );
}

export default AnalyticsCard;
